export default __webpack_public_path__ + "static/social-banner-565c2327ae11a0000375b7e4e015bdae.jpg";